import e from "../../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/objectWithoutProperties.js";
import t from "../../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/objectSpread2.js";
import { Button as n } from "../primitives/button.js";
import * as r from "react";
import { jsx as i } from "react/jsx-runtime";
//#region src/components/composed/button-icon.tsx
var a = ["icon", "aria-label"], o = r.forwardRef((r, o) => {
	let { icon: s, "aria-label": c } = r, l = e(r, a);
	return /* @__PURE__ */ i(n, t(t({
		ref: o,
		size: "icon",
		"aria-label": c
	}, l), {}, { children: s }));
});
o.displayName = "ButtonIcon";
//#endregion
export { o as ButtonIcon };

//# sourceMappingURL=button-icon.js.map